import { createFileRoute } from "@tanstack/react-router";
import { tabSearch } from "@/app/tabs";
import { PendingSurface } from "@/components/feedback/pending-surface";
import { settingsSections } from "@/features/settings";
import { requirePerm } from "@/lib/auth/guards";

export const Route = createFileRoute("/_authenticated/settings")({
  // Retired `?tab=` ids resolve to the tab that absorbed them — `app/tabs.ts`.
  validateSearch: tabSearch("settings"),
  beforeLoad: requirePerm("admin.staff"),
  component: SettingsRoute,
});

/**
 * The section the address names, or the pending surface when the address
 * names none this registry holds. The staff list is not prefetched: this
 * page does not read it yet, and a failed call must not close the door.
 */
function SettingsRoute() {
  const { tab } = Route.useSearch();
  const sections = settingsSections.use();
  const section = tab ? sections.find((item) => item.id === tab) : undefined;
  if (!section) return <PendingSurface titleKey="nav.settings" />;
  const { Component } = section;
  return <Component />;
}
